import { Reference } from '../reference.model';

const AUTO_GENERATED_PLACEHOLDER_TEXT = 'Auto generated at export';

/**
 * Returns the user-facing display text for a reference item.
 */
export const getReferenceDisplayValue = (reference: Reference): string => {
  if (reference?.csl) {
    return reference.bib || reference.csl.rawCitation || reference.csl.title || '';
  }
  return AUTO_GENERATED_PLACEHOLDER_TEXT;
};

/**
 * Compares references by primary author surname (or display text fallback).
 */
export const compareReferencesByAuthor = (a: Reference, b: Reference): number => {
  const aName = a?.csl?.author?.[0]?.family || getReferenceDisplayValue(a);
  const bName = b?.csl?.author?.[0]?.family || getReferenceDisplayValue(b);
  return aName.localeCompare(bName);
};
